import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './styles/FlashMessage.scss';

const ALERT_TYPES = [
  'primary',
  'secondary',
  'success',
  'danger',
  'warning',
  'info',
  'light',
  'dark'
];

/** Displays a message to the user using Bootstrap's Alert component. */

const FlashMessage = ({ dismissible, message, type }) => (
  <div className={classnames('alert', 'flash-message', `alert-${type}`, dismissible ? 'alert-dismissible' : null)}>
    {message}
    {
      dismissible && (
        <button type='button' className='btn-close' data-bs-dismiss='alert' aria-label='Close' />
      )
    }
  </div>
);

FlashMessage.propTypes = {
  /** Can the alert be dismissed */
  dismissible: PropTypes.bool,

  /** Content of the alert */
  message: PropTypes.string.isRequired,

  /** Type of alert */
  type: PropTypes.oneOf(ALERT_TYPES)
};

FlashMessage.defaultProps = {
  dismissible: true,
  type: 'success'
};

export default FlashMessage;
